import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-urc-card',
  templateUrl: './urc-card.component.html',
  styleUrls: ['./urc-card.component.scss'],
})
export class UrcCardComponent  implements OnInit {

	@Input() title: string;

  constructor() { }

  ngOnInit() {}

}
